/**
 * SiloRestingBand — the public "this silo is resting" state
 * (TRIAL_PLAN.md §8.10 · D17 · D39).
 *
 * Deliberately not a 404 and deliberately not an error: the creator's
 * subscription ended, so new answers are paused. Nothing is deleted, tips still
 * work, and anyone who already paid for a month is still being served — they
 * never see this.
 */
import { Moon, Heart } from "@phosphor-icons/react";

export default function SiloRestingBand({ siloName, onTip }) {
  return (
    <section
      className="siloart-encased max-w-3xl mx-auto px-6 py-10 text-center"
      data-testid="public-silo-resting"
    >
      <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] tpl-muted mb-5">
        <Moon size={15} weight="duotone" /> Resting
      </div>
      <h2 className="tpl-display text-3xl sm:text-4xl leading-tight">
        {siloName} is resting.
      </h2>
      <p className="mt-5 text-sm tpl-muted leading-relaxed max-w-xl mx-auto">
        Its creator's subscription has ended, so new answers are paused for now.
        Nothing has been deleted — every document and every answer is still here, and it all
        comes straight back if they return.
      </p>
      {onTip && (
        <button
          type="button"
          onClick={onTip}
          data-testid="public-silo-resting-tip"
          className="mt-7 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium tpl-btn transition-colors"
        >
          <Heart size={15} weight="duotone" /> Leave {siloName} a tip anyway
        </button>
      )}
      <p className="mt-4 text-[11px] tpl-muted">
        Tips are still accepted and still reach the creator.
      </p>
    </section>
  );
}
